import { FETCH_NEWS, ADD_NEWS, EDIT_NEWS, DELETE_NEWS, DESTROY_NEWS } from "../actionTypes";

export const fetchNews = news => ({
    type: FETCH_NEWS,
    news
});

export const addNews = news => ({
    type: ADD_NEWS,
    news
});

export const deleteNews = id => ({
    type: DELETE_NEWS,
    id
});

export const editNews = news => ({
    type: EDIT_NEWS,
    news
});

export const destroyNews = key => ({
    type: DESTROY_NEWS,
    key
});